import React from 'react';

import { Path, UseControllerProps, useController } from 'react-hook-form';

import { PriceLabelRow } from '../../../components/PriceLabelRow/PriceLabelRow';
import { CreateSubscriptionFormValues } from '../../../../../interfaces/createSubscription';

type ViewPriceInputProps = { label: string } & Pick<
  UseControllerProps<CreateSubscriptionFormValues, Path<CreateSubscriptionFormValues>>,
  'control' | 'name'
>;

const ViewPriceInput = ({ label, control, name }: ViewPriceInputProps) => {
  const {
    field: { value },
  } = useController({ control, name });

  return <PriceLabelRow label={label} value={value as string | number} />;
};

export { ViewPriceInput, ViewPriceInputProps };
